import { createStore, getActionIds } from '../helpers/redux';
import Immutable from 'immutable';
import { UserActions } from '../actions/user';
import { AccountActions } from '../actions/account';
import { OrganizationActions } from '../actions/organization';
import { AuthActions } from '../actions/auth';
// import { ProjectActions } from '../actions/project';

const userActions = getActionIds(UserActions);
const authActions = getActionIds(AuthActions);
// const projectActions = getActionIds(ProjectActions);
const accountActions = getActionIds(AccountActions);
const organizationActions = getActionIds(OrganizationActions);

const initialState = Immutable.fromJS({
  avatars: {},
});

export const avatars = createStore(initialState, {
  // [projectActions.resetReducers]: (state, action) => {
  //   return initialState;
  // },

  [authActions.getMe.success]: (state, action) =>
    state.mergeDeep({
      avatars: action.result.entities.avatars,
    }),

  [userActions.addProjectUser.success]: (state, action) => {
    if (!action.result.entities.avatars) return state;

    return state.mergeDeep({
      avatars: action.result.entities.avatars,
    });
  },

  [accountActions.addUser.success]: (state, action) => {
    if (!action.result.entities.avatars) return state;

    return state.mergeDeep({
      avatars: action.result.entities.avatars,
    });
  },

  [accountActions.getAccountUsers.success]: (state, action) => {
    if (!action.result.entities.avatars) return state;

    return state.mergeDeep({
      avatars: action.result.entities.avatars,
    });
  },

  [organizationActions.addUser.success]: (state, action) => {
    if (!action.result.entities.avatars) return state;

    return state.mergeDeep({
      avatars: action.result.entities.avatars,
    });
  },

  [organizationActions.getOrganizationUsers.success]: (state, action) => {
    if (!action.result.entities.avatars) return state;

    return state.mergeDeep({
      avatars: action.result.entities.avatars,
    });
  },

  [userActions.updateAvatar.success]: (state, action) =>
    state.mergeDeep({
      avatars: action.result.entities.avatars,
    }),

  [userActions.deleteAvatar.success]: (state, action) =>
    state.deleteIn(['avatars', action.args[1]]),

  [userActions.getProjectUsers.success]: (state, action) => {
    const res = action.result.entities.avatars;

    if (!res) return state;
    // temp fix for undefined key: https://github.com/paularmstrong/normalizr/issues/152
    Object.keys(res).forEach(k => {
      if (k === 'undefined') {
        delete res[k];
      }
    });

    return state.mergeDeep({
      avatars: res,
    });
  },
});

export const avatarsSelector = state => state.avatars.get('avatars');
export const avatarSelector = (state, props) => {
  return state.avatars.getIn(['avatars', props.currentUser.get('avatar_id')]);
};



// WEBPACK FOOTER //
// ./src/reducers/avatars.js